"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Utils = __importStar(require("../utils"));
var settlements_json_1 = __importDefault(require("./settlements.json"));
var establishments_1 = __importDefault(require("../establishments"));
var settlementType = function () { return Utils.pick(Object.keys(settlements_json_1.default.types)); };
var _population = function (settlementType) {
    var population = Utils.rand(settlements_json_1.default.types[settlementType].minPop, settlements_json_1.default.types[settlementType].maxPop);
    return population.toLocaleString();
};
exports.generate = function (props) {
    if (props === void 0) { props = {}; }
    var type = props.type, seed = props.seed;
    seed = seed || Utils.FantasyContentGeneratorSeed || Utils.generateUUID();
    return Utils.withSeed(seed, function () {
        type = type ? type : settlementType();
        return {
            seed: seed,
            type: type,
            population: _population(type),
            establishments: [
                establishments_1.default.generate({ seed: seed + "-1" }),
                establishments_1.default.generate({ seed: seed + "-2" }),
                establishments_1.default.generate({ seed: seed + "-3" }),
            ],
        };
    });
};
var functions = {
    generate: exports.generate,
};
exports.default = functions;
